// Prices follow the shipping country, not a currency the visitor picks: Bosnia pays the
// KM price, Serbia the RSD price, everyone else the EUR price. A running A/B price test
// (for the visitor's group) beats a country's own price, which beats the default. Mirrors
// Product::currencyForCountry and Product::basePriceFor in the backend, which recompute
// the order total the same way.

// Bulka stores Montenegro as CG; IP lookups (and the Atelje storefront) say ME.
export const normalizeCountry = (country) => (country === 'ME' ? 'CG' : country);

export function currencyForCountry(country) {
  switch (normalizeCountry(country)) {
    case 'BA': return 'KM';
    case 'RS': return 'RSD';
    default: return 'EUR';
  }
}

/** The running A/B price test for this country, if the product has one. */
const priceTestFor = (product, country) =>
  (product?.price_tests || []).find(test => (test.countries || []).includes(normalizeCountry(country)));

/**
 * The product with its price (and sale price) for this country and price group: a running
 * A/B test's price for the group, else the country's own price, else unchanged.
 */
export function applyCountryPrice(product, country, group = 'A') {
  const currency = currencyForCountry(country);
  const test = priceTestFor(product, country);
  const override = test && test.currency === currency
    ? test[group === 'B' ? 'B' : 'A']
    : product?.country_prices?.[normalizeCountry(country)];
  if (override === undefined || override === null || override === '') return product;

  const price = Number(override);
  const discount = Number(product.sale_discount_percentage) || 0;
  const salePrice = discount > 0 ? Math.round((price - (price * discount) / 100) * 100) / 100 : price;

  return {
    ...product,
    [currency]: price.toFixed(2),
    [`discounted_${currency}`]: discount > 0 ? salePrice : price.toFixed(2),
  };
}

export const applyCountryPrices = (products, country, group) =>
  (products || []).map(product => applyCountryPrice(product, country, group));
